// This container builds the app structure with react-router
// Author: @SG

import React from 'react';
import './App.css';

/**
 * THIRDPARTY IMPORTS
 */
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import WIHeader from './../../components/WIHeader';
import WIFooter from './../../components/WIFooter';
import Login from './../Auth/Login';
import Navigation from './../../components/Navigation';
import Loading from './../../components/Loading';
import ErrorCatch from './../../components/ErrorCatch';

import { DictonaryProvider } from './../../context/dictonary-content';

/**
 * UTIL IMPORTS
 */
import { generateRoutes } from '../../utils/RoutesGenerator';
import i18n from '../../utils/i18n';
import ApiService from './../../utils/ApiService';

/**
 * ROUTES IMPORTS
 */
import NotFound from '../../components/NotFound';

const { Footer } = Layout;

class App extends React.Component {
  state = {
    loading: true,
    error: null,
    navData: []
  };

  componentDidMount() {
    ApiService.meta()
      .navigation()
      .then(resp => {
        this.setState({
          loading: false,
          navData: resp.data,
          error: null
        });
      })
      .catch(err => {
        this.setState({
          loading: false,
          error: err.response ? err.response.status : err
        });
      });
  }

  render() {
    if (this.state.loading) {
      return (
        <Layout className="base-layout-wrapper">
          <div
            style={{
              textAlign: 'center',
              padding: 25
            }}
          >
            <Loading />
          </div>
        </Layout>
      );
    }

    if (this.state.error !== null) {
      if (this.state.error !== 401) {
        return (
          <Layout className="base-layout-wrapper">
            <div
              style={{
                textAlign: 'center',
                padding: 25
              }}
            >
              <h3>{i18n.errors.error404}</h3>
              <details>{this.state.error.toString()}</details>
            </div>
          </Layout>
        );
      } else {
        return <Login />;
      }
    }

    const { navData } = this.state;
    const reactRouterRoutes = generateRoutes(navData);
    return (
      <Router>
        <Layout className="base-layout-wrapper">
          <Route
            render={props => (
              <WIHeader navData={navData} location={props.location} />
            )}
          />
          <Layout>
            <Route
              render={props => (
                <Navigation navData={navData} location={props.location} />
              )}
            />

            <ErrorCatch>
              <Switch>
                <DictonaryProvider>{reactRouterRoutes}</DictonaryProvider>
                <Route component={NotFound} />
              </Switch>
            </ErrorCatch>
          </Layout>
          <Footer
            style={{
              height: 60,
              lineHeight: '60px',
              padding: 0,
              paddingLeft: 24
            }}
          >
            <Route
              render={props => (
                <WIFooter
                  showBackButton={
                    props.location.state
                      ? props.location.state.showBackButton
                      : false
                  }
                  buttons={
                    props.location.state ? props.location.state.buttons : null
                  }
                  history={props.history}
                  location={props.location}
                />
              )}
            />
          </Footer>
        </Layout>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js